import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

const store = createStore({
  // state:{},
  state: {
    userInfo: {}, //个人信息
    reportNo: '', // 体检编号
    idNumber: '', // 移动端身份证
    checkupId: '', // 移动端体检编号
    LoginStatus: '', // 登录模式：2：身份证号登录 1：体检号码登录
    questionType: {}, //问卷类型
    Age: '',//年龄，问卷提交接口需要
    gender: '',//性别
    customName: '',//姓名
  },
  mutations: {
    SET_USERINFO_ITEM: (state, data) => {
      state.userInfo = data
    },
    SET_AGE: (state, data) => {
      state.Age = data
    },
    SET_REPORTNO_ITEM: (state, data) => {
      state.reportNo = data
    },
    SET_CHECKUPID_ITEM: (state, data) => {
      state.checkupId = data
    },
    SET_LOGINSTATUS_ITEM: (state, data) => {
      state.LoginStatus = data
    },
    SET_IDNUMBER_ITEM: (state, data) => {
      state.idNumber = data
    },
    SET_QUESTIONTYPE_TIEM: (state, data) => {
      state.questionType = data
    },
    SET_CUSTOMERNAME: (state, data) => {
      state.customerName = data
    }
  },
  getters: {
    userInfo: (state) => {
      state.userInfo
    }
  },
  actions: {},
  modules: {},
  plugins: [createPersistedState({
    storage: window.sessionStorage,
    reducer(state) {
      let stateCopy = state
      return stateCopy
    }
  })]
})
export default store